import React from "react";
import styled from "styled-components";

import { formatTimestamp } from "./utils";
import { ProjectCommentPackage } from "./types";
import { UsableComment } from "./shared-components";

interface Props {
  comment: ProjectCommentPackage;
  used: boolean;
  use: () => void;
  usedHidden: boolean;
}

function ProjectFinancialComment(props: Props) {
  const {
    comment: { projectId, description, content, modifiedBy, modified },
    used,
    use,
    usedHidden,
  } = props;

  return (
    <UsableComment used={used} usedHidden={usedHidden} use={use}>
      <CommentSubtitle>
        <Commenter>{modifiedBy}</Commenter>
        <CommentDate>{formatTimestamp(modified)}</CommentDate>
      </CommentSubtitle>
      <CommentHeader>
        <CommentTypeDesc>{projectId}</CommentTypeDesc>
        <CommentTypeDesc>{description}</CommentTypeDesc>
      </CommentHeader>
      <CommentText>{content}</CommentText>
    </UsableComment>
  );
}

export default ProjectFinancialComment;

const CommentSubtitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 10px;
  font-weight: normal;
`;

const Commenter = styled.div`
  display: flex;
`;

const CommentDate = styled.div`
  display: flex;
`;

const CommentHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 12px;
`;

const CommentTypeDesc = styled.div`
  display: flex;
  font-size: 14px;
`;

const CommentText = styled.div`
  font-size: 12px;
  white-space: normal;
  font-weight: normal;
  white-space: break-spaces;
`;
